import { createReducer } from 'redux-act';

import {
  SHOPPERS_FETCH_DATA_INIT,
  SHOPPERS_FETCH_DATA_SUCCESS,
  SHOPPERS_FETCH_DATA_FAIL,
  SHOPPERS_DELETE_SHOPPER_INIT,
  SHOPPERS_DELETE_SHOPPER_SUCCESS,
  SHOPPERS_DELETE_SHOPPER_FAIL,
  SHOPPERS_CLEAR_DATA,
  SHOPPERS_CREATE_SHOPPER_INIT,
  SHOPPERS_CREATE_SHOPPER_SUCCESS,
  SHOPPERS_CREATE_SHOPPER_FAIL,
  SHOPPERS_MODIFY_SHOPPER_INIT,
  SHOPPERS_MODIFY_SHOPPER_SUCCESS,
  SHOPPERS_MODIFY_SHOPPER_FAIL,
  SHOPPERS_CLEAN_UP,
  SHOPPERS_CLEAR_DATA_LOGOUT,
  SHOPPERS_SYNC_SHOPPER_INIT,
  SHOPPERS_SYNC_SHOPPER_SUCCESS,
  SHOPPERS_SYNC_SHOPPER_FAIL,
} from 'state/actions/shopper';

const initialState = {
  list: [],
  shopper: {},
  loading: false,
  downloading: false,
  error: {
    errors: null,
    message: '',
  },
  success: false,
  deleted: false,
};

export const shopperReducer = createReducer(
  {
    [SHOPPERS_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [SHOPPERS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.list || [],
      shopper: payload.poi || initialState.shopper,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [SHOPPERS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SHOPPERS_DELETE_SHOPPER_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SHOPPERS_DELETE_SHOPPER_SUCCESS]: (state, payload) => ({
      ...state,
      list: state.list.filter((elem) => elem._id !== payload.id),
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      deleted: true,
    }),
    [SHOPPERS_DELETE_SHOPPER_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SHOPPERS_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [SHOPPERS_CREATE_SHOPPER_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SHOPPERS_CREATE_SHOPPER_SUCCESS]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
    }),
    [SHOPPERS_CREATE_SHOPPER_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SHOPPERS_MODIFY_SHOPPER_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [SHOPPERS_MODIFY_SHOPPER_SUCCESS]: (state) => ({
      ...state,

      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: true,
    }),
    [SHOPPERS_MODIFY_SHOPPER_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [SHOPPERS_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: {
        errors: null,
        message: '',
      },
      success: false,
      deleted: false,
    }),
    [SHOPPERS_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
    [SHOPPERS_SYNC_SHOPPER_INIT]: (state) => ({
      ...state,
      downloading: true,
    }),
    [SHOPPERS_SYNC_SHOPPER_SUCCESS]: (state) => ({
      ...state,
      downloading: false,
      error: {
        errors: null,
        message: '',
      },
    }),
    [SHOPPERS_SYNC_SHOPPER_FAIL]: (state, payload) => ({
      ...state,
      downloading: false,
      error: payload.error,
    }),
  },
  initialState
);
